import { useQuery, useRequiredParams } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export const useCandidateDetails = () => {
  const { id: programId, candidateId } = useRequiredParams()
  const { grantsService } = useServices()

  const [{ data: candidate, isLoading: isLoadingCandidate, error: candidateError }, { refresh: refreshCandidate }] =
    useQuery(grantsService.getCandidate, { programId, candidateId })

  const [{ data: documents, isLoading: isLoadingDocuments, error: documentsError }, { refresh: refreshDocuments }] =
    useQuery(grantsService.getCandidateDocuments, { candidateId })

  const [{ data: nominations, isLoading: isLoadingNominations, error: nominationsError }] = useQuery(
    grantsService.getCandidateNominations,
    { programId, candidateId }
  )
  const [
    { data: formSubmissions, isLoading: isLoadingFormSubmissions, error: formSubmissionsError },
    { refresh: refreshFormSubmissions }
  ] = useQuery(grantsService.getCandidateFormSubmissions, { programId, candidateId })

  return {
    data: {
      candidate,
      documents: documents ?? [],
      nominations: nominations || [],
      // Filter out submissions with no answers (document submissions)
      formSubmissions: formSubmissions?.filter(s => s.formAnswers.length > 0) || []
    },
    errors: {
      candidateError,
      nominationsError,
      formSubmissionsError,
      documentsError
    },
    refresh: {
      formSubmissions: refreshFormSubmissions,
      candidate: refreshCandidate,
      documents: refreshDocuments
    },
    isLoading: isLoadingCandidate || isLoadingNominations || isLoadingFormSubmissions || isLoadingDocuments
  }
}
